import { axios, createFormData, handleError } from '../axios';

export const updateRates = (data, webservice = false) => {
  return new Promise((resolve, reject) => {
    axios
      .post(webservice ? 'admin/setting/wrates' : 'admin/setting/rates', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
